import React from "react";

export const CtvmOrder = () =>{

    return (
        <>
            <p>CTVM Order is Pending</p>
        </>
    )
}